<!-- Divider -->
<div
    class="fakturnia-horizontal-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
